import { Field, FieldArray, useFormikContext } from "formik";
import { Button, Modal } from "react-bootstrap";
import React, { useState, useEffect, useContext } from "react";
import AddToolTip from "../../../components/AddToolTip";
import {
  FieldDropSide,
  SearchableList,
  CsplTable as Table,
  FieldInputDollar,
  FieldInput,
  PayrollCardHeader,
  PayrollCardBody,
} from "../../../components";
import {
  getNullTableItem,
  OPTIONS_DATA_MAPPER,
  toOptionValuesFromMapper,
  usDateFormat,
  usCurrency,
} from "../../../utils";
// import plan from "../../../mocks/planName.json";
import { filter, get, isEmpty, camelCase, set } from "lodash";
import { useDeepEffect } from "../../../abstracts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faTrashAlt,
  faTimes,
  faExclamationTriangle,
} from "@fortawesome/pro-light-svg-icons";
import authService from "../../../components/api-authorization/AuthorizeService";
import permissions from "../../../mocks/menuPermissions.json";
import { managePayrollStore } from "../../../contexts";
import { faSort } from "@fortawesome/pro-solid-svg-icons";
// const paydates = [
//   { label: "12/01/2021", value: "12/01/2021" },
//   { label: "13/02/2021", value: "13/02/2021" },
//   { label: "14/03/2021", value: "14/03/2021" },
// ];
// let x = paydates.length === 1 ? paydates[0].value : null;

const headerData = [
  {
    label: "Plan ID",
    className: "column-contribution-plan-id",
    icon: faSort,
  },
  {
    label: "Contribution source",
    className: "column-contribution-source",
    icon: faSort,
  },
  {
    label: "Pay period contribution",
    className: "column-contribution-pay-period",
    icon: faSort,
  },
  {
    label: "YTD contribution",
    className: "column-contribution-ytd",
    icon: faSort,
  },
  {
    label: "Calculated value",
    className: "column-contribution-calculated-value",
    icon: faSort,
  },
  {
    label: "Action",
    className: "column-contribution-action",
  },
];

const columns = [
  // {
  //   label: "Select",
  //   className: "column-select",
  //   columnName: "",
  // },
  {
    label: "Plan ID",
    className: "column-compensation-planid ft-12",
    columnName: "planId",
  },
  {
    label: "Contribution source",
    className: "column-compensation-contribution-src ft-12",
    columnName: "sourceName",
  },
  {
    label: "Pay period contribution ",
    className: "column-contribution-amt ft-12",
    columnName: "contributionAmount",
  },
  {
    label: "YTD contribution",
    className: "column-ytd-contribution-amt ft-12",
    columnName: "ytdContributionAmount",
  },
  {
    label: "Calculated value",
    className: "column-compensation-calculated-value ft-12",
    columnName: "calculatedValue",
  },
  {
    label: "Action",
    className: "column-removebutton",
    columnName: "removebutton",
  },
];

const PayrollContributionDetails = ({
  fields,
  data,
  errorList,
  setErrorList,
  paydate,
  pendingSubmission,
  contributionId,
  menu,
  subMenu,
  isWarningSlide,
}) => {
  const {
    values,
    setFieldValue,
    handleChange,
    errors,
    setErrors,
    setFieldTouched,
    setFieldError,
  } = useFormikContext();
  // const contributionsDetails = get(values, fields.contributionsDetails, []);
  const [isModalOpen, setIsModalOpen] = useState(0);
  const [recordToDelete, setRecordToDelete] = useState({});
  const [deleteContributionId, setDeleteContributionId] = useState(null);
  const [showClass, setShowClass] = useState(true);
  const [deleteContributionarray, setDeleteContributionarray] = useState([]);
  const { state, dispatch } = useContext(managePayrollStore);
  const [payDates, setPayDates] = useState([]);
  const [id, setId] = useState([]);
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  let contAmt = 0,
    calcAmt = 0;

  let temp = data.map((_) => _.payDate);
  let paydates = temp.map((_) => usDateFormat(_));
  let uniquepaydates = [...new Set(paydates)];
  let x = uniquepaydates.length === 1 ? uniquepaydates[0] : null;

  const contributionDetailsRecordType =
    values[fields.contributionDetailsRecordType];

  useDeepEffect(() => {
    data.map((contribution, index) => {
      contribution?.errorMessages?.map((_, i) => {
        if (_.controlName !== "ytdContributionAmount") {
          setFieldTouched(
            `${fields.contributionsDetails}[${index}].contributionAmount`,
            true
          );
          setFieldError(
            `${fields.contributionsDetails}[${index}].contributionAmount`,
            _.messageDescCode
          );
        }
      });
    });
  }, [data]);

  useDeepEffect(() => {
    let tempPayDates = values[fields.planId]
      ? data.filter(
          (contribution) => contribution.rkPlanNumber === values[fields.planId]
        )
      : data;
    tempPayDates = tempPayDates.map((contribution) => contribution.payDate);
    setPayDates(
      tempPayDates.filter(
        (item, i, tempPayDates) => tempPayDates.indexOf(item) === i
      )
    );
  }, []);

  const removeOne = (item) => {
    setIsModalOpen(true);
    setRecordToDelete(item);
  };
  const onDeleteConfirmClick = () => {
    let deletedContributionIndex = null;
    let list = data.filter((item, index) => {
      if (item.id === deleteContributionId) deletedContributionIndex = index;
      return item.id !== deleteContributionId;
    });
    let tempErrors = { ...errors };
    // const selectedId = get(recordToDelete, "planId");
    set(
      tempErrors,
      `contributions.${deletedContributionIndex}.contributionAmount`,
      null
    );
    data.forEach((cont, ind) => {
      if (ind > deletedContributionIndex && ind > 0) {
        set(
          tempErrors,
          `contributions.${ind - 1}`,
          get(tempErrors, `contributions.${ind}`, null)
        );
      }
    });
    if (errorList && errorList.contributions) {
      delete errorList.contributions[deletedContributionIndex];
      for (
        let i = deletedContributionIndex;
        i < errorList.contributions.length;
        i++
      ) {
        errorList.contributions[`${i}`] = errorList.contributions[`${i + 1}`];
      }
    }
    // errorList.contributions = error;
    console.log("errorList", errorList);
    setErrorList(errorList);
    setErrors({ ...tempErrors });
    deleteContributionarray.push(deleteContributionId);
    setDeleteContributionarray(deleteContributionarray);
    setFieldValue(fields.contributionsDetails, list);
    setFieldValue(fields.deletedContributionIds, deleteContributionarray);
    setIsModalOpen(false);
    // setRecordToDelete({});
  };
  console.log("errorList", errorList);

  const handleClose = () => {
    setIsModalOpen(false);
    setRecordToDelete({});
  };

  const fullText = () => {
    setShowClass(!showClass);
  };

  const check = (data) => {
    var error = data.errorMessages.filter((e) => {
      return e.errorType !== 1;
    });
    if (!isEmpty(error)) {
      setId([...id, error[error.length - 1].id]);
      contributionId([...id, error[error.length - 1].id]);
    }
  };
  const handleContributionChange = (e, name, index) => {
    const current = e.target.value;
    const fieldVal = `${fields.contributionsDetails}[${index}].ytdContributionAmount`;
    const contr = get(values, name);
    const ytd = get(values, fieldVal) + (current - contr);
    setFieldValue(name, current);
    setFieldValue(fieldVal, ytd);
    handleChange(e);
  };

  return (
    <div className="payroll-contribution-details">
      <div className="plan-sub-heading">Contribution Details</div>
      <div className="ft-12 mb-20">
        Review and correct the contribution amounts. Use the action buttons
        above to update the employee’s record
      </div>
      <div className="d-flex">
        <Field
          isRequired
          label="Show"
          size="smd"
          disabled={pendingSubmission || isWarningSlide}
          placeholder="Show"
          name={fields.contributionDetailsRecordType}
          value={values[fields.contributionDetailsRecordType]}
          direction="bottom"
          options={toOptionValuesFromMapper(
            OPTIONS_DATA_MAPPER.RECORD_TYPES_OPTIONS
          )}
          popupContent={
            <SearchableList
              label="Select record type"
              options={toOptionValuesFromMapper(
                OPTIONS_DATA_MAPPER.RECORD_TYPES_OPTIONS
              )}
              onSelect={(value) =>
                setFieldValue(fields.contributionDetailsRecordType, value)
              }
              selectedValue={values[fields.contributionDetailsRecordType]}
              name={fields.contributionDetailsRecordType}
              isNotTypeAhead
              isRadio
            />
          }
          component={FieldDropSide}
        />
        &nbsp;&nbsp;&nbsp;
        {/* <Field
          isRequired
          label="Pay date"
          size="smd"
          placeholder=""
          name={fields.paydateContribution}
          // value={usDateFormat(values[fields.paydateContribution])}
          value={x ? x : usDateFormat(values[fields.paydateContribution])}
          disabled={x ? "true" : null}
          direction="bottom"
          popupContent={
            <SearchableList
              label="Select pay date"
              options={payDates.map((date) => ({
                label: usDateFormat(date),
                value: date,
              }))}
              // options = {paydates}
              onSelect={(value) =>
                setFieldValue(fields.paydateContribution, value)
              }
              selectedValue={usDateFormat(values[fields.payDates])}
              name={fields.paydateContribution}
              isNotTypeAhead
              isRadio
            />
          }
          component={FieldDropSide}
        /> */}
        <Field
          isRequired
          label="Pay date"
          size="sm"
          placeholder=""
          name={fields.paydateContribution}
          value={x}
          disabled={
            x
              ? true
              : false || pendingSubmission || isEmpty(data) || isWarningSlide
          }
          direction="bottom"
          component={FieldInput}
        />
      </div>
      <FieldArray name={fields.contributionsDetails}>
        {({ remove, push }) => {
          return (
            <>
              <div className="payroll-card-container">
                <PayrollCardHeader headerData={headerData} />
                {!isEmpty(data) ? (
                  <>
                    {data.map((contribution, index) => {
                      let errorType = null;
                      if (!isEmpty(contribution.errorMessages)) {
                        errorType = contribution.errorMessages.find(
                          (_) => _.errorType == 2
                        )?.errorType;
                      }

                      return (
                        <PayrollCardBody
                          fieldName={`${fields.contributionsDetails}[${index}]`}
                          isContribution={true}
                          disabled={pendingSubmission || isWarningSlide}
                          handleChange={handleChange}
                          errorList={errorList}
                          menu={menu}
                          planId={contribution?.rkPlanNumber}
                          subMenu={subMenu}
                          roleName={roleName}
                          removeOne={removeOne}
                          contribution={contribution}
                          errorType={errorType == 2 ? 2 : 1}
                          index={index}
                          check={check}
                          values={values}
                          handleContributionChange={handleContributionChange}
                          setDeleteContributionId={setDeleteContributionId}
                          setIsModalOpen={setIsModalOpen}
                        />
                      );
                    })}
                  </>
                ) : (
                  <div className="d-flex justify-content-center payroll-accept-card">
                    No data available
                  </div>
                )}
              </div>
            </>
          );
        }}
      </FieldArray>
      <Modal show={isModalOpen} onHide={handleClose}>
        <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
          <div className="text-right">
            <FontAwesomeIcon
              icon={faTimes}
              color="#000"
              onClick={handleClose}
            />
          </div>
          <div className="d-flex">
            <div className="pd-15">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                color="#f94f50"
                size="3x"
              />
            </div>
            <div className="remove-text">
              <h4>Delete Error ?</h4>
              <p>
                Are you sure you want to delete selected Contribution details?
                Deleted information cannot be retrieved or restored
              </p>
              <br />
              <Button
                className="remove-btn mr-4"
                onClick={onDeleteConfirmClick}
              >
                Delete
              </Button>
              <Button className="cancel-btn" onClick={handleClose}>
                Cancel
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default PayrollContributionDetails;
